module.exports = __webpack_public_path__ + "img/water04.1888592a.png";